import { createContext } from 'react'
import { UserModel } from '../utils/models'

if (!process.env.GATSBY_AUTH_NAMESPACE) {
  throw new Error('No GATSBY_AUTH_NAMESPACE is provided.')
}

const AUTH_NAMESPACE = process.env.GATSBY_AUTH_NAMESPACE.trim().replace(/\/+$/, '')

enum UserRoles {
  ProductAdmin = 'ProductAdmin',
  OrganizationAdmin = 'OrganizationAdmin',
  MainOrg = 'MainOrg',
}

interface IUserContext {
  user: UserModel | undefined
}

export class UserContextModel implements IUserContext {
  public user: UserModel | undefined
  constructor(user: UserModel | undefined) {
    this.user = user
  }

  isProductAdmin() {
    return this?.user?.[`${AUTH_NAMESPACE}/roles`].includes(UserRoles.ProductAdmin)
  }

  isOrganizationAdmin(): boolean {
    if (!this.user?.[`${AUTH_NAMESPACE}/roles`]) {
      throw new Error('Bad user context.')
    }

    return this.user?.[`${AUTH_NAMESPACE}/roles`].includes(UserRoles.OrganizationAdmin)
  }

  isMainOrg() {
    if (!this.user?.[`${AUTH_NAMESPACE}/roles`]) {
      throw new Error('Bad user context.')
    }

    return this?.user?.[`${AUTH_NAMESPACE}/roles`].includes(UserRoles.MainOrg)
  }
  getOrganizationName() {
    if (!this.user?.[`${AUTH_NAMESPACE}/org_name`]) {
      throw new Error('Bad user context.')
    }

    return this.user?.[`${AUTH_NAMESPACE}/org_name`]
  }

  getLanguage() {
    if (!this.user?.[`${AUTH_NAMESPACE}/language`]) {
      throw new Error('Bad user context.')
    }

    return this.user?.[`${AUTH_NAMESPACE}/language`]
  }

  getStudies() {
    if (!this.user?.[`${AUTH_NAMESPACE}/studies`]) {
      throw new Error('Bad user context.')
    }

    return this.user?.[`${AUTH_NAMESPACE}/studies`]
  }
  getProductAdminIn() {
    return this.user?.[`${AUTH_NAMESPACE}/productAdminIn`]
  }
  getOrgAdminIn() {
    return this.user?.[`${AUTH_NAMESPACE}/orgAdminIn`]
  }
}

export default createContext<UserContextModel>(new UserContextModel(undefined))
